export const PRICE = /^\d*((,|\.)\d{0,2})?$/;
